import { createContext } from "react";
import { ISelectedContext } from "@interfaces/ISelectedContext";

export const SelectedServiceContext = createContext({} as ISelectedContext);
